// extracted by mini-css-extract-plugin
export default {"warning":"out-of-stock-message__warning___ZQLXA"};